// extracted by mini-css-extract-plugin
module.exports = {"container":"loader-overlay-module__container__3bAe-"};